
import { Injectable, Inject, EventEmitter } from '@angular/core';
import { EventInteraction } from "../../dynamic/event.interaction.service";
import { CoreEffects } from '../../../state/effect/core.effects';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class VideoPlayerControlService {
    private STATE_KEY = "_VideoPlayerControlState"

    constructor(protected coreEffects: CoreEffects) {
        let defaultState =  {
            isTheaterMode:false,
            isFullScreen:false,
            isCasting:false,
            volumeLevel:1
        }
        this.updateState(defaultState);
        //todo: monitor controls state change, persist in local-storage
    }

    getPlayerControlState(): any {
        return this.coreEffects.getInternalStateValue(this.STATE_KEY);
    }

    private updateState(obj:any) {
        const oldState = this.getPlayerControlState() || {};
        const newState = Object.assign(oldState, obj);
        this.coreEffects.setInternalStateValue(this.STATE_KEY, newState);
    }

    setVolumeState(level:number) {
        this.updateState({ volumeLevel: level });
    }

    setTheaterModeState(state:boolean) {
        this.updateState({ isTheaterMode: state });
    }

    setFullScreenState(state:boolean) {
        this.updateState({ isFullScreen: state });
    }

    setCastingState(state:boolean) {
        this.updateState({ isCasting: state });
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/videoplayer/videoplayer-control.service.ts